export default "__VITE_ASSET__CqcVW4T$__"